import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote2 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>COLLABORATIVE ATTACKS AND DEFENSE</b> <br/>
            Prof. Bharat Bhargava <br/>
            IEEE Fellow<br />
            Purdue University<br />
            Department of Computer Sciences, West Lafayette, Indiana, USA <br />
            <br />
            <div style={{fontSize: "small", marginBottom: "1rem" }}>Date and Time: December 13, 2023 (morning)</div>
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            Flying Ad Hoc Networks (FANETs) are becoming increasingly crucial in a variety of civil and military applications, including wildfire monitoring and suppression, search and rescue operations in hazardous scenarios, and transport of supplies or personnel to remote locations. Going beyond protecting FANETs from single forms of attacks, we address collaborative attacks (CA) within these networks. A collaborative attack occurs when attackers synchronize their malicious actions against a target FANET. The collaboration can occur simultaneously, where multiple attackers attempt to compromise the system at the same time or split in time where one attacker gathers the information about the network and subsequently another attacker executes the actual exploit. We are developing a systematic understanding of the threats imposed by collaborative attacks along with the formulation of intelligent and effective defenses. 
            </div>

            <h6 className="par_header">Speaker's Biography:</h6>
            <div className="par">
            Bharat Bhargava is a professor of computer science at Purdue University. He led a Northrup Grumman sponsored consortium on Real Applications of Machine Learning (REALM) with MIT, CMU, and Stanford.
            <br />
            He contributed to the Department of Defense on The Science of Artificial Intelligence and Learning for Open-world Novelty (SAIL-ON) project. He works with Sandia Corporation on science and technology for advancing resilience for contested space (STARCS) to maintain mission capabilities of the US Space Enterprise, Jet Propulsion Lab to predict attacks on space systems and Ford Corporation on software defined networking for V2V communication.
            <br />
            Prof. Bhargava has won eight best paper awards in addition to the technical achievement award and golden core award from IEEE and is a fellow of IEEE. He is a distinguished alumni of Indian Institute of Science and DAV college. He received the highest award for incoming graduate student in IIT Delhi. He is major thesis advisor of the very first African American woman to receive her Ph. D in the history of Computer Science department at Purdue in May 2019.He has graduated the largest number of Ph. Ds in CS at Purdue and a very large number of women Ph.Ds. He was awarded the Focus award to help differently abled persons and Schleman Gold Medallion award for supporting women at Purdue.

            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/Bhargava.png" height="300px" alt=""/>
            </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote2;